'use client'

import { usePathname } from 'next/navigation'
import React from 'react'

import { LAST_VIEW_KEY } from '@/shared/new-posts-notifier'

export default function Template({ children }: { children: React.ReactNode }) {
    const pathname = usePathname()

    // biome-ignore lint/correctness/useExhaustiveDependencies: only run on mount
    React.useEffect(() => {
        if (pathname === '/') {
            localStorage.setItem(LAST_VIEW_KEY, Math.floor(Date.now() / 1000).toString())
        }
    }, [])

    return <div>{children}</div>
}
